import routes from '@/modules/profit/routes'
import store from '@/modules/profit/store'

export default { routes, store }
